import React from "react"
import Image from "../../imagev2"
import tw, {css} from "twin.macro"

const BlogImagenDoble = ({content}) => {
    const {data} = content
    console.log(data)
    const blocks = data.blocks
    let aspectratio = 9999
    if (blocks[0] && blocks[1]) {
        aspectratio = 2.0 - Math.min(blocks[0].image?.aspectratio, blocks[1].image?.aspectratio)

    }
    console.log(aspectratio)

    return (
        <div css={tw`my-6 pb-1`}>
            <div
                css={cssImageColumnsContainer}
                style={{
                    paddingTop: `${aspectratio * 50}%`
                }}
            >
                <div
                    css={cssImageColumnsContent}>
                    {
                        blocks.map((block, idx) => (
                            <div css={cssImage}
                                 key={idx}
                            >
                                <Image key={idx}
                                       objectFit={"contain"} f
                                       imageTablet={block.image}
                                       imageMobile={block.image_mobile}
                                       widths={["720px", "640px", "880px"]}

                                />
                            </div>
                        ))
                    }</div>
            </div>
            {data.texto_con_formato2 && (
                <div
                    css={[cssTexto]}
                    dangerouslySetInnerHTML={{__html: data.texto_con_formato2}}
                />
            )}
        </div>
    )
}

export default BlogImagenDoble
const cssTexto = css`
  &,
  & * {
    ${tw`text-obsssmall2 leading-16em md:text-obsmall md:leading-loose`}
  }
`

const cssImageColumnsContainer = css`
  ${tw`relative`}
`
const cssImageColumnsContent = css`
  ${tw`absolute inset-0 flex flex-row`}
`

const cssImage = css`
  ${tw`w-full h-full`}
  &:first-child {
    flex: calc(50% - 2px);
    margin-right: 3px;
  }

  &:last-child {
    flex: calc(50% - 1px);
  }
`